// GA4 event tracking. Replace G-XXXXXXXXXX in public/index.html with the real measurement ID.
export const trackEvent = (name, params = {}) => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("event", name, params);
    }
};
